import React from 'react';

import { Button, Space } from 'antd';
import { useTranslation } from 'react-i18next';

import { useCountry } from 'entities/country';
import styles from './EmptyTable.module.scss';

export const EmptyTable: React.FC = () => {
  const { t } = useTranslation('Country');

  const { setSearchName } = useCountry();

  return (
    <Space align="center" direction="vertical">
      <div>{t('EmptyTable.title')}</div>
      <Button type="link" className={styles.resetSearchingBtn} onClick={() => setSearchName('')}>
        {t('EmptyTable.viewAllCountries.text')}
      </Button>
    </Space>
  );
};
